import { lazy } from 'react'

import { Routes } from '@infrastructure/navigation/routes'
import verticalNavigation from '@infrastructure/navigation/vertical'

import { name } from '../repository'

const basePath = '/recommendation-group-prototypes'

Routes.push({
  path: basePath,
  component: lazy(() => import('../components/RecGroupPrototypesPage')),
  meta: {
    authRoute: true
  }
})

verticalNavigation.prototypesSection.children.push({
  id: name,
  title: 'Групи Рекомендацій',
  navLink: basePath
})
